var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 pt-6" },
        [
          _c(
            "v-col",
            { staticClass: "pl-0", attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("img", {
                        staticClass: "arrow px-4 py-3",
                        attrs: { src: _vm.ic_back, id: "back-btn" },
                        on: { click: _vm.backToPrevPage },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v(_vm._s(_vm.backToLbl) + " "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "px-16 mb-12 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10", attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: {
                        xl: "9",
                        lg: "9",
                        md: "11",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v(_vm._s(_vm.pageHeader)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-n5", attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: {
                        xl: "9",
                        lg: "9",
                        md: "11",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("label", { staticClass: "page-sub-header" }, [
                        _vm._v(
                          "The table compares different LTL carriers and on average how many days it took the carrier to run the shipment vs what was estimated."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: {
                        xl: "9",
                        lg: "9",
                        md: "11",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _vm._l(_vm.selectedGroups, function (carrier) {
                            return _c(
                              "v-col",
                              {
                                key: carrier.scac,
                                attrs: {
                                  xl: "4",
                                  lg: "4",
                                  md: "6",
                                  sm: "12",
                                  cols: "12",
                                },
                              },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "br-10 px-3 add-comp",
                                    attrs: { elevation: "0" },
                                  },
                                  [
                                    _c("v-card-text", [
                                      _c(
                                        "div",
                                        { staticClass: "card-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-text" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "carrier-info-lbl",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        carrier.carrierName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "carrier-info-lbl",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(carrier.scac) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("img", {
                                            staticClass: "hover",
                                            attrs: { src: _vm.ic_delete },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeGroupFromSelected(
                                                  carrier.scac
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _c(
                            "v-col",
                            {
                              attrs: { cols: "auto" },
                              on: {
                                click: function ($event) {
                                  _vm.comparisonPopup = true
                                },
                              },
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "br-10 px-3 hover add-comp",
                                  attrs: { elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "v-row",
                                                { attrs: { align: "center" } },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "mt-1",
                                                      attrs: { cols: "2" },
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: _vm.ic_plus_light_blue,
                                                          width: "16",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "10" } },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "add-comparison-lbl hover",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Add comparison"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: {
                        xl: "9",
                        lg: "9",
                        md: "11",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "br-10 px-3 pb-3 pr-8",
                          attrs: { elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-2 ml-2",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "transit-search-header",
                                        },
                                        [_vm._v("Filter")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-n2 ml-2",
                                      attrs: {
                                        cols: "12",
                                        xl: "4",
                                        lg: "5",
                                        md: "6",
                                        sm: "12",
                                      },
                                    },
                                    [
                                      _c("smart-combobox", {
                                        attrs: {
                                          items: _vm.timeSlots,
                                          label: "Time Slot",
                                        },
                                        on: { change: _vm.applyFilters },
                                        model: {
                                          value: _vm.selectedTimeSlot,
                                          callback: function ($$v) {
                                            _vm.selectedTimeSlot = $$v
                                          },
                                          expression: "selectedTimeSlot",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.selectedGroups.length
                                    ? _c("v-col", { attrs: { cols: "12" } }, [
                                        _c(
                                          "div",
                                          { staticClass: "chart-legend" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "chart-legend-item",
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "chart-legend-color chart-dark",
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chart-legend-name",
                                                  },
                                                  [_vm._v("Estimated")]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "chart-legend-item",
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "chart-legend-color chart-pink",
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chart-legend-name",
                                                  },
                                                  [_vm._v("Actual")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "bar-chart-horizontal",
                                          },
                                          [
                                            _vm._l(
                                              _vm.selectedGroups,
                                              function (item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.scac,
                                                    staticClass:
                                                      "chart-element",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "chart-name",
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var on =
                                                                      ref.on
                                                                    var attrs =
                                                                      ref.attrs
                                                                    return [
                                                                      _c(
                                                                        "span",
                                                                        _vm._g(
                                                                          _vm._b(
                                                                            {
                                                                              staticClass:
                                                                                "hover",
                                                                            },
                                                                            "span",
                                                                            attrs,
                                                                            false
                                                                          ),
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.scac
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Based on " +
                                                                  _vm._s(
                                                                    _vm.formatWeight(
                                                                      _vm.basedOn(
                                                                        item.scac
                                                                      )
                                                                    )
                                                                  ) +
                                                                  " shipments"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "chart-lines-group",
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var on =
                                                                      ref.on
                                                                    var attrs =
                                                                      ref.attrs
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        _vm._g(
                                                                          _vm._b(
                                                                            {
                                                                              staticClass:
                                                                                "chart-line hover",
                                                                              style:
                                                                                "width: " +
                                                                                ((item.estTransDays /
                                                                                  _vm.maxActTransDays) *
                                                                                  100 >
                                                                                100
                                                                                  ? 100
                                                                                  : (item.estTransDays /
                                                                                      _vm.maxActTransDays) *
                                                                                    100) +
                                                                                "%",
                                                                            },
                                                                            "div",
                                                                            attrs,
                                                                            false
                                                                          ),
                                                                          on
                                                                        )
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  "Est Avg " +
                                                                    item.estTransDays +
                                                                    " days"
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var on =
                                                                      ref.on
                                                                    var attrs =
                                                                      ref.attrs
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        _vm._g(
                                                                          _vm._b(
                                                                            {
                                                                              staticClass:
                                                                                "chart-line hover",
                                                                              style:
                                                                                "width: " +
                                                                                ((item.actTransDays /
                                                                                  _vm.maxActTransDays) *
                                                                                  100 >
                                                                                100
                                                                                  ? 100
                                                                                  : (item.actTransDays /
                                                                                      _vm.maxActTransDays) *
                                                                                    100) +
                                                                                "%",
                                                                            },
                                                                            "div",
                                                                            attrs,
                                                                            false
                                                                          ),
                                                                          on
                                                                        )
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  "Act Avg " +
                                                                    item.actTransDays +
                                                                    " days"
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "bg" },
                                              _vm._l(_vm.days, function (day) {
                                                return _c(
                                                  "span",
                                                  { key: day },
                                                  [
                                                    _c("b", [
                                                      _vm._v(_vm._s(day)),
                                                    ]),
                                                  ]
                                                )
                                              }),
                                              0
                                            ),
                                          ],
                                          2
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.selectedGroups.length
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "ta-c mt-7",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "chart-explainer" },
                                            [
                                              _vm._v(
                                                "Estimated Transit Days vs Actual Transit Days"
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  !_vm.selectedGroups.length
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "ta-c py-10",
                                          attrs: { cols: "12" },
                                        },
                                        [_c("no-data")],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px", scrollable: "" },
          model: {
            value: _vm.comparisonPopup,
            callback: function ($$v) {
              _vm.comparisonPopup = $$v
            },
            expression: "comparisonPopup",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "br-10 px-2 comparison-popup" },
            [
              _c(
                "v-card-title",
                { staticClass: "h-80" },
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs11: "",
                            sm11: "",
                            md11: "",
                            lg11: "",
                            xl11: "",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "add-edit-instruction-heading" },
                            [_vm._v("Add Comparison ")]
                          ),
                        ]
                      ),
                      _c(
                        "v-flex",
                        {
                          staticClass: "ta-r",
                          class: {
                            "mr-4": _vm.smAndDown,
                          },
                          attrs: {
                            xs1: "",
                            sm1: "",
                            md1: "",
                            lg1: "",
                            xl1: "",
                          },
                        },
                        [
                          _c("v-menu", {
                            attrs: { bottom: "", left: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "close-btn",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                _vm.comparisonPopup = false
                                              },
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("img", {
                                          attrs: { src: _vm.ic_close },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _vm._l(_vm.groups, function (group) {
                    return _c(
                      "v-row",
                      {
                        key: group.scac,
                        staticClass: "bg-white px-4 pt-3 my-3 br-8 mr-1",
                      },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pl-0", attrs: { cols: "auto" } },
                          [
                            _vm.showAdd(group.scac)
                              ? _c("smart-btn", {
                                  staticClass: "fr mt-n2 add-remove-type",
                                  attrs: {
                                    label: "Add",
                                    icon: _vm.ic_plus,
                                    "icon-class": "mr-3",
                                    "icon-width": "12",
                                    "loading-icon-width": "38",
                                    "icon-position": "left",
                                    type: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.add(group.scac)
                                    },
                                  },
                                })
                              : _vm._e(),
                            !_vm.showAdd(group.scac)
                              ? _c("smart-btn", {
                                  staticClass: "fr mt-n2 add-remove-type",
                                  attrs: {
                                    label: "Remove",
                                    bg: "white",
                                    border: "navy-blue",
                                    font: "navy-blue",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.remove(group.scac)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "mt-n1", attrs: { cols: "auto" } },
                          [
                            _c("label", { staticClass: "equipment-text" }, [
                              _vm._v(_vm._s(group.carrierName)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  !_vm.groups.length
                    ? _c("v-row", { staticClass: "px-4 pt-3 my-3 br-8 mr-1" }, [
                        _c("label", { staticClass: "page-sub-header" }, [
                          _vm._v("No available carriers.."),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-4" },
                [
                  _c("v-spacer"),
                  _c("smart-btn", {
                    staticClass: "mr-4",
                    class: _vm.smAndDown ? "hidden" : "",
                    attrs: { type: "dismiss", label: "Cancel" },
                    on: {
                      click: function ($event) {
                        _vm.comparisonPopup = false
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v("Loading Transit Times"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }